import React from 'react';

import Copyright from '../Copyright/Copyright';

import './Footer.scss';

const Footer = () => {
  return (
    <div className="footer">
      <Copyright />
    </div>
  )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js